import { InsightsTab } from '../types';
import useInsightCardViewInfo from './useInsightCardViewInfo';
import { useGetChannelOptionsQuery } from 'src/services/insights';
import { FilterOptionsResponse } from 'src/services/insights/types';
import { ConversationChannel } from 'src/types/workflowBuilderAPITypes';

export default function useGetChannelOptions(noPrefix = false) {
  const { data, isLoading } = useGetChannelOptionsQuery();

  const options = (data?.data ?? []).map(channelObj => ({
    label: channelObj.label,
    value: noPrefix ? channelObj.value : `channels.${channelObj.value}`,
  }));

  return { isLoading, options };
}

export function useGetChannelOptionsForSolveInsights(
  noPrefix = false,
  tab?: InsightsTab | 'assist',
) {
  const { data } = useGetChannelOptionsQuery();

  const { channels, isInsightCardView } = useInsightCardViewInfo();

  const normalizedData =
    (isInsightCardView || tab === 'topic'
      ? isInsightCardView
        ? data?.data.filter(({ value }) =>
            channels.includes(value as ConversationChannel),
          )
        : data?.data
      : data?.data.filter(isWidgetRelatedChannel)) || [];

  const options = normalizedData.map(channelObj => ({
    label: channelObj.label,
    value: noPrefix ? channelObj.value : `channels.${channelObj.value}`,
  }));

  return options;
}

const isWidgetRelatedChannel = (
  channel: FilterOptionsResponse['data'][number],
) =>
  channel.value === 'widget' ||
  channel.value === 'sunshine' ||
  channel.value === 'kustomer_sms' ||
  channel.value === 'intercom_sms';
